import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { CCLocation } from '../../../../models/locations-models/cc-location';
import { CCRowSetting } from '../../../../models/locations-models/cc-row-setting';
import { CCDataPerLocation } from './cc-list-state';

export const ccLocationsAdapter: EntityAdapter<CCLocation> = createEntityAdapter<CCLocation>({
  selectId: model => model.placeId, // unique ID
});

export const ccRowSettingsAdapter: EntityAdapter<CCRowSetting> = createEntityAdapter<CCRowSetting>({
  selectId: model => model.placeId, // unique ID
});

export const ccDataAdapter: EntityAdapter<CCDataPerLocation> = createEntityAdapter<CCDataPerLocation>();
